module.exports = __webpack_public_path__ + "static/img/2_4.2ae0bb41.jpg";